/**
 * Created by CCristi on 11/14/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StrategyFactory = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CustomStrategy = require('./CustomStrategy');

var _deepCore = require('deep-core');

var _deepCore2 = _interopRequireDefault(_deepCore);

require('./InternalErrorStrategy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// browserify fix

let StrategyFactory = exports.StrategyFactory = function () {
  function StrategyFactory() {
    _classCallCheck(this, StrategyFactory);
  }

  _createClass(StrategyFactory, null, [{
    key: 'create',

    /**
     * @param {String|Function} strategy
     * @param {Object[]} args
     * @returns {AbstractStrategy}
     */
    value: function create() {
      let strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'internal-error';

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (typeof strategy === 'string') {
        const strategyFullName = `${StrategyFactory._pascalCase(strategy)}Strategy`;
        const StrategyProto = require(`./${strategyFullName}`)[strategyFullName];

        return new (Function.prototype.bind.apply(StrategyProto, [null].concat(args)))();
      } else if (typeof strategy === 'function') {
        return new (Function.prototype.bind.apply(_CustomStrategy.CustomStrategy, [null].concat([strategy], args)))();
      }

      throw new _deepCore2.default.Exception.InvalidArgumentException(strategy, 'string|function');
    }

    /**
     * @param {String} str
     * @returns {String}
     */

  }, {
    key: '_pascalCase',
    value: function _pascalCase(str) {
      return str.split(/[^a-zA-Z0-9]+/).reduce((pascalString, part) => {
        return pascalString + part.charAt(0).toUpperCase() + part.slice(1);
      }, '');
    }
  }]);

  return StrategyFactory;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/RetryStrategy/StrategyFactory.js
// module id = 100
// module chunks = 0